import { render, staticRenderFns } from "./BanSettings.vue?vue&type=template&id=5a83cf4b&scoped=true"
import script from "./BanSettings.vue?vue&type=script&lang=js"
export * from "./BanSettings.vue?vue&type=script&lang=js"
import style0 from "./BanSettings.vue?vue&type=style&index=0&id=5a83cf4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83cf4b",
  null
  
)

export default component.exports